<template>
  <v-dialog v-model="dialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Sửa trạng thái đơn</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="mt-4 mb-4">
            <CardStudentInfo :student="uniformOrderData.student" link />
          </v-col>
        </v-row>
        <div>
          <v-row>
            <!-- Trạng thái hiện tại -->
            <v-col cols="12" style="padding-bottom: 0px; height: 50px">
              <v-divider />
              <div class="mt-4">
                <span> Chuyển trạng thái</span>
              </div>
            </v-col>
            <v-col
              cols="5"
              style="align-content: center; padding-bottom: 0px; padding-top: 0px; height: 60px"
            >
              <v-chip :color="getStatusColor(uniformOrderData.status)" small class="white--text">
                {{ getStatusText(uniformOrderData.status) }}
              </v-chip>
            </v-col>
            <v-col
              cols="2"
              class="text-center"
              style="align-content: center; padding-bottom: 0px; padding-top: 0px; height: 60px"
            >
              <v-icon color="grey" size="36">mdi-arrow-right</v-icon>
            </v-col>
            <v-col cols="5" style="align-content: center; padding-bottom: 0px; padding-top: 0px; height: 60px">
              <v-select
                v-model="newStatus"
                :items="statusOptions"
                label="Trạng thái mới"
                outlined
                dense
                hide-details
                :disabled="isStatusDisabled"
              />
            </v-col>
            <!-- Danh sách đơn hàng -->
            <v-col cols="12">
              <v-divider />
              <div class="mt-4 mb-2">
                <span style="font-weight: bold">Danh sách đồng phục</span>
              </div>
              <ul style="margin-top: 5px; list-style-type: none; padding-left: 10px" class="fix-height-dialog-confirm">
                <li v-for="(item, index) in uniformOrderData.uniformItems" :key="index">
                  <v-list-item-content style="padding-top: 0px; padding-bottom: 4px">
                    <span>
                      {{ item.name }} - {{ item.optionOne }} - {{ item.optionTwo }} | SL: {{ item.quantity }} | Giá:
                      {{ formatCurrency(item.price) }}
                    </span>
                  </v-list-item-content>
                </li>
              </ul>
              <div
                class="total-price-wrapper d-flex justify-space-between align-center"
                style="border-top: thin solid rgba(0, 0, 0, 0.12); padding-top: 10px"
              >
                <span>Tổng tiền</span>
                <span class="total-amount" style="color: red">{{ formatCurrency(uniformOrderData.totalPrice) }}</span>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined class="grey--text" @click="cancel">HUỶ</v-btn>
        <v-btn color="primary" @click="confirmChange">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import CardStudentInfo from '@/components/basic/card/CardStudentInfo.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    CardStudentInfo,
  },
  props: {
    state: Boolean,
    uniformOrderData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialog: false,
      newStatus: 'cancelled', // Chỉ cho phép chuyển trạng thái thành "cancelled"
    }
  },
  methods: {
    ...mapActions('UniformOrdersRegister', ['updateStatusStudent']),

    getStatusColor(status) {
      switch (status) {
        case 'pending':
          return '#FFA726' // Màu cam - Chờ duyệt
        case 'confirmed':
          return '#4CAF50' // Màu xanh lá cây - Đã xác nhận
        case 'cancelled':
          return '#616161' // Màu ghi đậm - Đã hủy
        default:
          return '#9E9E9E' // Màu xám tối - Không xác định
      }
    },
    getStatusText(status) {
      const statusTexts = {
        pending: 'Chờ duyệt',
        confirmed: 'Đã xác nhận',
        cancelled: 'Đã hủy',
      }
      return statusTexts[status] || 'Không xác định'
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
      }).format(value)
    },
    cancel() {
      this.dialog = false
    },
    async confirmChange() {
      if (!this.newStatus) {
        this.$alert.error('Vui lòng chọn trạng thái mới')
        return
      }
      this.$loading.active = true
      try {
        await this.updateStatusStudent({
          id: this.uniformOrderData.id,
          status: this.newStatus,
        })
        this.$alert.addSuccess('Cập nhật trạng thái thành công!')
        this.$emit('updated')
        this.dialog = false
      } catch (error) {
        this.$alert.addError('Có lỗi xảy ra khi cập nhật trạng thái!')
      } finally {
        this.$loading.active = false
      }
    },
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.newStatus = 'cancelled' // Mặc định chuyển trạng thái thành "cancelled"
      }
    },
  },
  computed: {
    isStatusDisabled() {
      return (
        (this.uniformOrderData.statusReturned === 'waiting_returned' ||
          this.uniformOrderData.statusReturned === 'complete_returned') &&
        this.uniformOrderData.status === 'confirmed'
      )
    },

    statusOptions() {
      return [
        { value: 'cancelled', text: 'Đã hủy' }, // Chỉ cho phép chọn "Đã hủy"
      ]
    },
  },
}
</script>

<style>
.text-muted {
  color: #888;
  font-size: 14px;
}
.fix-height-dialog-confirm {
  height: 150px !important;
  max-height: 300px;
  overflow: auto;
  padding-right: 18px;
}
.total-price-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  font-weight: bold;
}
ul {
  list-style-type: disc !important;
  margin-left: 20px;
}
</style>
